import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Menu, MenuItem } from "@mui/material";
import { FilterIcon } from "../../components/icons/Filter";

interface ManagerFilterProps {
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
}

export function ManagerFilter({ statusFilter, onStatusFilterChange }: ManagerFilterProps) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleStatusFilterChange = (value: string) => {
    onStatusFilterChange(value);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="contained"
        disableElevation
        sx={{
          background: "#2d2f32",
          margin: 0,
          padding: "0 10px",
          borderRadius: "999px",
          textTransform: "none",
          fontFamily: "Montserrat",
          fontWeight: 300,
          minWidth: "100px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "white",
          "&:hover": {
            background: "#3d3f42"
          }
        }}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        startIcon={<FilterIcon />}
        endIcon={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#EF0BB8"
            strokeWidth="0"
          >
            <path
              d="M5.707 9.71a1 1 0 0 0 0 1.415l4.892 4.887a2 2 0 0 0 2.828 0l4.89-4.89a1 1 0 1 0-1.414-1.415l-4.185 4.186a1 1 0 0 1-1.415 0L7.121 9.71a1 1 0 0 0-1.414 0Z"
              fill="#EF0BB8"
              stroke="none"
            />
          </svg>
        }
      >
        {t(`managers.filters.${statusFilter}`)}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        slotProps={{
          paper: {
            sx: {
              backgroundColor: "#2d2f32",
              color: "white",
              minWidth: "100px",
              marginTop: "2px",
              "& .MuiMenuItem-root": {
                fontFamily: "Montserrat",
                fontWeight: 300,
                "&:hover": {
                  backgroundColor: "#3d3f42"
                },
                "&.Mui-selected": {
                  backgroundColor: "#3d3f42",
                  "&:hover": {
                    backgroundColor: "#4d4f52"
                  }
                }
              }
            }
          }
        }}
      >
        <MenuItem onClick={() => handleStatusFilterChange("all")}>
          {t("managers.filters.all")}
        </MenuItem>
        <MenuItem onClick={() => handleStatusFilterChange("active")}>
          {t("managers.filters.active")}
        </MenuItem>
        <MenuItem onClick={() => handleStatusFilterChange("inactive")}>
          {t("managers.filters.inactive")}
        </MenuItem>
      </Menu>
    </>
  );
} 